// This mirrors isStaleLive and STALE_LIVE_AFTER_MS in services/events-api/src/lib/eventStatus.ts (ISSUE-1088).
// Mirrored, not imported, because an app cannot import service code, the same way goalserve-ingest-api
// mirrors it as STALE_EVENT_BACKSTOP_AFTER_MS (src/lib/ingest/ingestSchedule.ts). POST /round/get-board
// carries no isLive, so the survivor board applies the rule itself (ISSUE-1148). The test staleLiveRule.test.ts
// fails if the two drift.

/** A game in progress or delayed is not served as live if its kickoff was more than this far back. */
export const STALE_LIVE_AFTER_MS = 18 * 60 * 60 * 1000;

/**
 * True when a game is inProgress or delayed, and its kickoff is more than STALE_LIVE_AFTER_MS in the past.
 * This mirrors the events-api rule that gates isServedLive (eventStatus.ts:85).
 */
export function isStaleLive(input: {
  status: string | undefined;
  kickoffAt: string;
  nowMs: number;
}): boolean {
  const isLiveStatus =
    input.status === "inProgress" || input.status === "delayed";
  if (!isLiveStatus) {
    return false;
  }

  const kickoffMs = Date.parse(input.kickoffAt);
  if (Number.isNaN(kickoffMs)) {
    return false;
  }

  return input.nowMs - kickoffMs > STALE_LIVE_AFTER_MS;
}
